import { Entry } from '../Entry'

export function Entry20220209() {
  return (
    <Entry title="09/02/2022 - v3.0.0-beta-15">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12453/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
